import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/common/Button'
import Card from '@/components/common/Card'
import SeedTeamsTable from '@/components/admin/seedTeams/SeedTeamsTable'
import PendingPostingsTable from '@/components/admin/seedTeams/PendingPostingsTable'
import SeedTeamImport from '@/components/admin/seedTeams/SeedTeamImport'
import SeedHealthDashboard from '@/components/admin/seedTeams/SeedHealthDashboard'

export default function SeedTeamsPage() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('teams') // 'teams' | 'pending' | 'import' | 'health'

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => navigate('/dashboard')}
                className="text-gray-600 hover:text-gray-900"
              >
                ← Back
              </Button>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">
                  Seed Teams Management
                </h1>
                <p className="text-sm text-gray-600 mt-1">
                  Automated calendar sync and scrimmage opportunity detection
                </p>
              </div>
            </div>
          </div>

          {/* Tab Navigation */}
          <div className="flex gap-1 border-b border-gray-200">
            <button
              onClick={() => setActiveTab('teams')}
              className={`px-6 py-3 text-sm font-medium transition-colors ${
                activeTab === 'teams'
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900 border-b-2 border-transparent'
              }`}
            >
              Teams
            </button>
            <button
              onClick={() => setActiveTab('pending')}
              className={`px-6 py-3 text-sm font-medium transition-colors ${
                activeTab === 'pending'
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900 border-b-2 border-transparent'
              }`}
            >
              Pending Postings
            </button>
            <button
              onClick={() => setActiveTab('import')}
              className={`px-6 py-3 text-sm font-medium transition-colors ${
                activeTab === 'import'
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900 border-b-2 border-transparent'
              }`}
            >
              Import
            </button>
            <button
              onClick={() => setActiveTab('health')}
              className={`px-6 py-3 text-sm font-medium transition-colors ${
                activeTab === 'health'
                  ? 'text-blue-600 border-b-2 border-blue-600'
                  : 'text-gray-600 hover:text-gray-900 border-b-2 border-transparent'
              }`}
            >
              Health
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <Card>
          <div className="p-6 bg-blue-50 border border-blue-200 rounded-lg">
            <h2 className="text-sm font-semibold text-blue-900 uppercase tracking-wide">
              How the Scrimmage Seed Pipeline Works
            </h2>
            <ol className="mt-3 space-y-2 text-sm text-blue-900 list-decimal list-inside">
              <li><strong>Import teams</strong> (CSV or manual) with accurate level/tier and rink details.</li>
              <li><strong>Run “Sync”</strong> on the Teams tab to pull calendars & detect solo ice.</li>
              <li><strong>Review Pending Postings</strong> to approve auto-detected scrimmage opportunities. Approved postings go live on the scrimmage bulletin.</li>
            </ol>
            <p className="mt-3 text-xs text-blue-800">
              Tip: Syncing can take ~20 seconds per team while we geocode the rink and score confidence. High-confidence solo ice (≥ 80) floats to the top of the Pending Postings tab.
            </p>
          </div>
        </Card>

        {activeTab === 'teams' && <SeedTeamsTable />}
        {activeTab === 'pending' && <PendingPostingsTable />}
        {activeTab === 'import' && <SeedTeamImport />}
        {activeTab === 'health' && <SeedHealthDashboard />}
      </div>
    </div>
  )
}

